//
// UP Button
//

( function($, waTheme) {

    var ButtonUp = (function ($) {

        ButtonUp = function (options) {
            var that = this;

            // DOM
            that.$window = $(window);
            that.$wrapper = options['$wrapper'];

            // VARS
            that.showClass = 'show';
            that.scrollTop = 300;
            that.animateTime = 300;

            // DYNAMIC VARS

            // EVENTS
            that.bindEvents();
        };

        ButtonUp.prototype.bindEvents = function () {
            var that = this;

            that.$window.scroll(function () {
                if (that.$window.scrollTop() > that.scrollTop) {
                    that.$wrapper.addClass(that.showClass);
                } else {
                    that.$wrapper.removeClass(that.showClass);
                }
            });

            that.$wrapper.on('click', function (e) {
                e.preventDefault();
                $('html, body').animate({scrollTop: 0}, that.animateTime);
            });

            // On vanilla JS
            //   const showOnPx = 300;
            //   const backToTopButton = document.querySelector(".c-backtotop");
            //
            //   const scrollContainer = () => {
            //     return document.documentElement || document.body;
            //   };
            //
            //   const goToTop = () => {
            //     document.body.scrollIntoView({
            //       behavior: "smooth"
            //     });
            //   };
            //
            //   document.addEventListener("scroll", () => {
            //     if (scrollContainer().scrollTop > showOnPx) {
            //       backToTopButton.classList.add("show");
            //     } else {
            //       backToTopButton.classList.remove("show");
            //     }
            //   });
            //
            //   backToTopButton.addEventListener("click", goToTop);
        };

        return ButtonUp;

    })($);

    waTheme.init.site.ButtonUp = ButtonUp;

    var $wrapper = $('.b-up-button');
    if ($wrapper.length) {
        new window.waTheme.init.site.ButtonUp({
            $wrapper: $wrapper,
        });
    }

})(jQuery, window.waTheme);
